module.exports = __webpack_public_path__ + "a8252e89988f1b1e3074ad24afa115f8.jpg";